import { createLogic } from "redux-logic";
import * as ActionTypes from "../../actions/actionTypes";
import * as AuthActions from "../../actions/authActions";

const authStatusChangedLogic = createLogic({
	type: ActionTypes.AUTH_STATUS_CHANGED,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		if (action.user) {
			dispatch(AuthActions.loginSucess(action.user));
		}
		done();
	},
});

export default [authStatusChangedLogic];
